import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  formatISO,
  parseISO,
  formatDistanceToNow,
  differenceInMilliseconds,
} from 'date-fns';
import { formatDate } from 'utils';
import { DataFormatter } from 'constants/global';

import { TimeMessage } from './RelativeTime.styled';
import Tooltip from '../Tooltip';

const MINUTE = 60 * 1000;
const HOUR = 60 * 60 * 1000;
const DAY = 24 * 60 * 60 * 1000;

export default function RelativeTime(props) {
  let relativeTimeMessage = '';
  const now = new Date();
  let datetime = props.date;
  if (!(datetime instanceof Date)) {
    datetime = parseISO(props.date);
  }
  const timeSinceNow = differenceInMilliseconds(now, datetime);
  let timeMagnitude;
  if (timeSinceNow < MINUTE) {
    timeMagnitude = MINUTE;
  } else if (timeSinceNow < HOUR) {
    timeMagnitude = MINUTE;
  } else if (timeSinceNow < DAY) {
    timeMagnitude = HOUR;
  } else {
    timeMagnitude = DAY;
  }
  if (!timeMagnitude) {
    timeMagnitude = MINUTE;
  }
  relativeTimeMessage = formatDistanceToNow(datetime, { addSuffix: true }); // {locale: props.locale}  -- locale is not currently passed

  const [relativeTime, setRelativeTime] = useState(relativeTimeMessage);

  useEffect(() => {
    const timer = setTimeout(() => {
      relativeTimeMessage = formatDistanceToNow(datetime, { addSuffix: true }); // locale(props.locale) - locale is not currently passed
      setRelativeTime(relativeTimeMessage);
    }, timeMagnitude || MINUTE);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <Tooltip
        delayShow={500}
        place='top'
        {...(props.tooltipProps || {})}
        id='relativeTimestamp'
      />
      <TimeMessage
        dateTime={formatISO(datetime)}
        data-for='relativeTimestamp'
        data-tip={formatDate(datetime, DataFormatter.full)}
      >
        {relativeTime}
      </TimeMessage>
    </>
  );
}

RelativeTime.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  locale: PropTypes.string,
};
